module.exports = __webpack_public_path__ + "static/media/JohnHopkins.dadd3141.png";